import {FeatureConstants} from "../actions/feature";
import {UserConstants} from "../actions/user";

const handlers = {
  [FeatureConstants.FEATURED_REQUEST]: (_state: FeatureState, _action: FeatureAction): FeatureState=> ({
    errorMessage: "",
  }),
  [FeatureConstants.FEATURED_SUCCESS]: (_state: FeatureState, action: FeatureAction): FeatureState => ({
    content: action.payload,
    errorMessage: undefined,
  }),
  [FeatureConstants.FEATURED_FAILURE]: (_state: FeatureState, action: FeatureAction): FeatureState => ({
    errorMessage: action.error,
  }),
};

export function featured(state: FeatureState = {}, action: RootActions): FeatureState {
  if (action.type === UserConstants.LOGIN_SUCCESS) {
    return {};
  }
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (handlers[(action as FeatureAction).type]) {
    return handlers[(action as FeatureAction).type].call(null, state, action as FeatureAction);
  }
  return state;
}
